import http from "./http";
import { Auth } from 'aws-amplify'

const headers = {
  headers: {
    "Authorization": ""
  }
};

export async function postBusinessMatch(config) {
  const session = await Auth.currentSession();
  const jwtToken = session.getIdToken().getJwtToken();

  headers.headers["Authorization"] = jwtToken;

  const response = await http.post("ep/business-search", config, headers);
  return response.data;
}

export async function getBespokeGoldenRecords() {
  const session = await Auth.currentSession();
  const jwtToken = session.getIdToken().getJwtToken();

  headers.headers["Authorization"] = jwtToken;

  const response = await http.get("ep/bespoke-golden-record", headers);
  return response.data;
}

export async function postBespokeGoldenRecord(config) {
  const session = await Auth.currentSession();
  const jwtToken = session.getIdToken().getJwtToken();

  headers.headers["Authorization"] = jwtToken;

  const response = await http.post("ep/bespoke-golden-record", config, headers);
  return response.data;
}

export async function downloadReport(data) {
  const response = await http.post("/biz-lookup-download-report", data, headers);
  return response.data;
}

export async function getMatchConfidenceTheshold() {
  const session = await Auth.currentSession()
  const jwtToken = session.getIdToken().getJwtToken()

  headers.headers['Authorization'] = jwtToken

  const response = await http.get('ep/match-confidence-threshold', headers)
  return response.data
}

export async function postMatchConfidenceTheshold(config) {
  const session = await Auth.currentSession()
  const jwtToken = session.getIdToken().getJwtToken()

  headers.headers['Authorization'] = jwtToken

  const response = await http.post('ep/match-confidence-threshold', config, headers)
  return response.data
}